/**
 * Een feitenblok: term links, waarde rechts, met een stand-chip waar
 * die iets betekent.
 *
 * Een blok zonder feiten toont altijd de reden waarom het leeg is. Stil
 * leeg blijven is de fout van 14 september: dan zoekt iemand een
 * storing die er niet is, of ziet hij een storing over het hoofd.
 */
import type { GezondheidBlok, GezondheidFeit } from "@/lib/werkplek-api";

const CHIPKLASSE: Record<string, string> = {
  goed: "wp-chip wp-chip-whatsapp",
  let_op: "wp-chip wp-chip-risico",
  uit: "wp-chip wp-chip-grijs",
};

function Chip({ feit }: { feit: GezondheidFeit }) {
  if (!feit.chip) return null;
  const klasse = feit.stand ? CHIPKLASSE[feit.stand] : undefined;
  return <span className={klasse ?? "wp-chip wp-chip-grijs"}>{feit.chip}</span>;
}

export function FeitenLijst({ blok }: { blok: GezondheidBlok }) {
  return (
    <div className="wp-blok">
      <h4>
        {blok.titel}
        {blok.ondertitel ? (
          <span
            style={{
              float: "right",
              textTransform: "none",
              letterSpacing: "normal",
              fontWeight: 400,
              color: "var(--wp-tekst3)",
            }}
          >
            {blok.ondertitel}
          </span>
        ) : null}
      </h4>
      {blok.feiten.length > 0 ? (
        <dl className="wp-gz-feiten">
          {blok.feiten.map((feit) => (
            <div className="wp-gz-feit" key={`${blok.titel}-${feit.term}`}>
              <dt>{feit.term}</dt>
              <dd>
                <span>{feit.waarde}</span>
                <Chip feit={feit} />
                {feit.toelichting ? (
                  <small className="wp-gz-toelichting">
                    {feit.toelichting}
                  </small>
                ) : null}
              </dd>
            </div>
          ))}
        </dl>
      ) : null}
      {blok.reden_leeg ? (
        <p className="wp-gz-uitleg" role="status">
          {blok.reden_leeg}
        </p>
      ) : null}
    </div>
  );
}

export function BlokkenKolom({
  blokken,
  isLoading,
  isError,
  watFoutGing,
}: {
  blokken: GezondheidBlok[] | undefined;
  isLoading: boolean;
  isError: boolean;
  watFoutGing: string;
}) {
  if (isLoading) {
    return <p className="wp-gz-uitleg">Bezig met laden…</p>;
  }
  if (isError || !blokken) {
    return (
      <p className="wp-gz-uitleg" style={{ color: "var(--wp-rood)" }}>
        {watFoutGing}
      </p>
    );
  }
  return (
    <>
      {blokken.map((blok) => (
        <FeitenLijst key={blok.titel} blok={blok} />
      ))}
    </>
  );
}
